import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import actions from "store/auth/actions";
import anonimizeHandler from "localStorage/anonymizeHandler";
import urls from "shared/appUrls";

const AnonymizeNavigation: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch: any = useDispatch();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const anonymizeParam = queryParams.get("anonymize");

    if (typeof anonymizeParam === "string") {
      const anonymize =
        anonymizeParam === "true" ||
        anonymizeParam === "on" ||
        anonymizeParam === "1";
      dispatch(actions.setAnonymization(anonymize));
      anonimizeHandler.setAnonymize(anonymize);
      navigate(urls.appRoot.index());
    }
  }, [location, navigate, dispatch]);

  return null;
};

export default AnonymizeNavigation;
